import { render } from "./onboarding-modal.vue?vue&type=template&id=b8326e4c&ts=true"
import script from "./onboarding-modal.vue?vue&type=script&lang=ts"
export * from "./onboarding-modal.vue?vue&type=script&lang=ts"

import "./onboarding-modal.vue?vue&type=style&index=0&id=b8326e4c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__